const translations = {
    aircraft: 'Aircraft',
    controller: 'Controller'
};

export default translations;
